<template>
    <BaseDialog
        :showDialog="showFileImportDialog"
        maxDialogWidth="600"
        maxCardHeight="600"
        headline="lang_GENERAL_FILE_IMPORT_DIALOG_TITLE_UPLOAD_FILE"
        :close="closeDialog"
        persistent
        :alvqa="alvqa"
    >
<!-- Dialog Text -->
        <template v-slot:dialogText>
            <v-container fluid> 
                <v-row>
                    <v-col 
                        v-html="dialogText"
                        :alvqa="alvqa + '-text'"
                    >
                    </v-col>
                </v-row>
                <v-row v-if="csvReportPath !== null">
                    <v-col>
                        {{ $t('lang_GENERIC_CAPTION_DOWNLOAD_CSV_REPORT') }}
                        <BaseIcon 
                            v-if="csvReportPath !== null"
                            @click.stop="downloadFile(csvReportPath)" 
                            icon="cloud_download" 
                            :tooltipText="$t('lang_GENERIC_CAPTION_DOWNLOAD_CSV_REPORT')" 
                            :alvqa="alvqa + '-icon-download-csv-report'" 
                        />
                    </v-col>
                </v-row>

<!-- Progressbars -->
                <v-row v-if="showUploadProgressbar">
                    <v-col>
                        <v-progress-linear 
                            v-model="uploadProgressbarValue"
                            height="25"
                            color="dialogProgressbar"
                            :alvqa="alvqa + '-upload-progressbar'"
                        ></v-progress-linear>
                    </v-col>
                </v-row>
            </v-container>          
        </template>

<!-- Actions + Validation -->
        <template v-slot:actionsWithValidation>
            <v-card-actions  v-if="showUploadActions" class="pt-0 pb-0 pr-6 pl-6">
                    <v-container fluid>
                        <v-form v-model="valid">
                            <v-row>
                                <v-col cols="8">
                                    <v-file-input
                                        v-model="file"
                                        :label="$t('lang_GENERAL_CAPTION_SELECT_FILE')"
                                        :rules="rules"
                                        @change="fileExt = $alvPlugin.extractFileExt(file)"
                                        @click:clear="resetVal()"
                                        show-size
                                        :alvqa="alvqa + '-file-input-import-file'"
                                    ></v-file-input>
                                </v-col>
                                <v-spacer />
                                <v-col 
                                    class="text-right" 
                                    align-self="center"
                                >
                                <BaseButton 
                                    :disabled="!valid || !file"
                                    @click="submitFile"
                                    label="lang_GENERAL_CAPTION_UPLOAD"
                                    :alvqa="alvqa+'-button-upload'"
                                />    
                                </v-col>
                            </v-row> 
                        </v-form>
                    </v-container>   
            </v-card-actions>
        </template>
    </BaseDialog>
</template>

<script>
import api from '@/api_alv'
import BaseDialog from '@/components/_base/BaseDialog'
import BaseButton from '@/components/_buttons/BaseButton'
import BaseIcon from '@/components/_buttons/BaseIcon'

export default {
    name: "InventoriesImportDialog",
    components: {
        BaseDialog,
        BaseButton,
        BaseIcon
    },
    props: {
        context: {
            type: String,
            default: ''
        },
        alvqaContext: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            valid: false,
            formData: new FormData(),
            file: null,
            fileExt: '',            
            showUploadProgressbar: false,
            showUploadActions: true,
            uploadProgressbarValue: 0,
            rules: [value => !value || this.fileExt === 'xlsx' || this.$t('lang_GENERAL_DIALOG_TEXT_INVALID_FORMAT') ],
            alvqa: 'erp-inventories-import-dialog',
            csvReportPath: null
        }
    },
    computed: {
        showFileImportDialog: {
            get() { return this.$store.getters.getShowInventoriesImportDialog },
            set(showFileImportDialog) { this.$store.commit('setShowInventoriesImportDialog', showFileImportDialog) }
        },
        dialogText: {
            get() { return this.$store.getters.getImportDialogText },
            set(text) { this.$store.commit('setImportDialogText', text) }
        },
    },
    methods: {
        // File upload to server and show the progress of the process or show errors if not successful.
        async submitFile() {            
            this.dialogText = this.$t('lang_GENERAL_FILE_UPLOAD_DIALOG_TEXT_FILE_IS_BEING_UPLOADED') 
            this.formData.append('file', this.file)  
            this.showUploadActions = false
            this.showUploadProgressbar = true             

            // API Call to upload a file
            let params = '?type=' + this.$store.getters.getSelectedInventoriesImport
            let uploadFileResponse = await api.putFile('erp/inventories', this.formData, params)
            this.uploadProgressbarValue = 100
            this.showUploadProgressbar = false

            if(uploadFileResponse.error === -1) {
                this.dialogText = this.$t('lang_GENERAL_FILE_UPLOAD_DIALOG_TEXT_UPLOAD_SUCCESS') + '<br /><br />' + this.$t('lang_GENERAL_DIALOG_TEXT_CLOSE_DIALOG')
                
            } else {
                let errorMsg = uploadFileResponse.response.errorMsg
                if(errorMsg !== null) {
                    this.dialogText = this.$alvPlugin.isLangConst(errorMsg) ? this.$t(errorMsg) : errorMsg 
                }
                this.csvReportPath = uploadFileResponse.response.path
                this.dialogText += '<br /><br />' + this.$t('lang_GENERAL_DIALOG_TEXT_CLOSE_DIALOG') 
            }
            this.$store.dispatch('fetchInventories')
        },

        async resetVal() {
            await this.$nextTick()
            this.file = null
        },                   

        downloadFile(path) {
            api.getFileFromALV(path)
        },
        // Close the FileImportDialog and sets back to default.
        closeDialog() {
            this.showFileImportDialog = false         
            this.showUploadProgressbar = false
            this.showUploadActions = true
            this.file = null
            this.formData = new FormData()
            this.uploadProgressbarValue = 0
            this.selectedFileImportOption = []
            this.dialogText = ''
            this.csvReportPath = null
            this.$store.commit('setSelectedInventoriesImport', [])
        }
    }
}
</script>

<style scoped>
.black-label {
    color: black;
}
</style>